import React from "react";

const Lock = (props) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="16"
    //   height="18"
    //   viewBox="0 0 16 18"
    //   fill="none"
    // >
    //   <path
    //     d="M8.00005 0C9.98827 0 11.6 1.61177 11.6 3.6V4.8H12.8C14.1255 4.8 15.2 5.87452 15.2 7.2V15.6C15.2 16.9255 14.1255 18 12.8 18H3.20005C1.87457 18 0.800049 16.9255 0.800049 15.6V7.2C0.800049 5.87452 1.87457 4.8 3.20005 4.8H4.40005V3.6C4.40005 1.61177 6.01182 0 8.00005 0ZM12.8 6H3.20005C2.53731 6 2.00005 6.53726 2.00005 7.2V15.6C2.00005 16.2627 2.53731 16.8 3.20005 16.8H12.8C13.4628 16.8 14 16.2627 14 15.6V7.2C14 6.53726 13.4628 6 12.8 6ZM8.00005 10.2C8.66279 10.2 9.20005 10.7373 9.20005 11.4C9.20005 12.0627 8.66279 12.6 8.00005 12.6C7.33731 12.6 6.80005 12.0627 6.80005 11.4C6.80005 10.7373 7.33731 10.2 8.00005 10.2ZM8.00005 1.2C6.67456 1.2 5.60005 2.27452 5.60005 3.6V4.8H10.4V3.6C10.4 2.27452 9.32553 1.2 8.00005 1.2Z"
    //     fill={props.lockWarning?"orange":"red"}
    //     fillOpacity="0.54"
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        d="M7.88976 0.00819401L8.16326 0C10.5511 0 12.5035 1.86401 12.6449 4.21629L12.6531 4.4898V5.30612H13.8776C15.2301 5.30612 16.3265 6.40257 16.3265 7.7551V17.551C16.3265 18.9036 15.2301 20 13.8776 20H2.44898C1.09645 20 0 18.9036 0 17.551V7.7551C0 6.40257 1.09645 5.30612 2.44898 5.30612H3.67347V4.4898C3.67347 2.10199 5.53748 0.149544 7.88976 0.00819401L8.16326 0L7.88976 0.00819401ZM8.16326 11.0204C7.26158 11.0204 6.53061 11.7514 6.53061 12.6531C6.53061 13.5548 7.26158 14.2857 8.16326 14.2857C9.06495 14.2857 9.79592 13.5548 9.79592 12.6531C9.79592 11.7514 9.06495 11.0204 8.16326 11.0204ZM8.37193 2.45952L8.16326 2.44898C7.1066 2.44898 6.2375 3.25204 6.13299 4.28113L6.12245 4.4898V5.30612H10.2041V4.4898C10.2041 3.43313 9.40102 2.56403 8.37193 2.45952L8.16326 2.44898L8.37193 2.45952Z"
        fill={props.lockWarning?"gray":"red"}
      />
    </svg>
  );
};

export default Lock;
